import "./style.scss";
export default function ContainerRed({ header, title }) {
  return (
    <div id="id_container_red">
      {header}
      {title && <div className="cls_container_title">{title}</div>}
    </div>
  );
}
